import {animate, style, transition, trigger} from '@angular/animations';

export const slideAnimationX = trigger('slideAnimationX', [
  transition(':enter', [
    style({
      transform: 'translateX(100%)',
      position: 'fixed',
    }),
    animate(
      '.6s cubic-bezier(.16,.78,.26,.99)',
      style({
        transform: 'translateX(0)',
      }),
    ),
  ]),
  transition(':leave', [
    style({
      transform: 'translateX(0)',
    }),
    animate(
      '.6s cubic-bezier(.16,.78,.26,.99)',
      style({
        transform: 'translateX(100%)',
      }),
    ),
  ]),
]);
